export default "__VITE_ASSET__B$bsrvfR__"